module.exports = __webpack_public_path__ + "img/marker-oil-refinery-grey.25beac3d.png";